import { Route, Routes } from 'react-router-dom';
import { PortalConversations } from './Conversations.js';
import { ConversationDetail } from './ConversationDetail.js';
import { TermsGate } from './Terms.js';
import { ScreenView } from '../../session/usage.js';
import { useFig } from '../../session/FigProvider.js';

/**
 * The Client Portal tree. Everything here sits behind RequireRole in App.tsx, and behind
 * TermsGate, which blocks the tree until acceptance is recorded.
 */
export function PortalRoutes() {
  const { client } = useFig();
  return (
    <TermsGate>
      <Routes>
        <Route index element={<ScreenView api={client} name="calls"><PortalConversations /></ScreenView>} />
        <Route path=":id" element={<ScreenView api={client} name="call"><ConversationDetail /></ScreenView>} />
      </Routes>
    </TermsGate>
  );
}
